export default __webpack_public_path__ + "media/images/projects/project-2025-from-space.jpg";